import { render, staticRenderFns } from "./AttributeEdit.vue?vue&type=template&id=080bd820&scoped=true&"
import script from "./AttributeEdit.vue?vue&type=script&lang=js&"
export * from "./AttributeEdit.vue?vue&type=script&lang=js&"
import style0 from "./AttributeEdit.vue?vue&type=style&index=0&id=080bd820&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "080bd820",
  null
  
)

export default component.exports